export const PROMOTIONS = 'Promotions';
export const INDIVIDUALBONUS = 'Individual Bonus';
export const CODEGENERATOR = 'Code Generator';